import React from 'react';
import './AdBanner.css';
import { ExternalLink, Megaphone } from 'lucide-react';

export function AdBanner({ currentUser, vipSettings }) {
  // Hide completely if user is VIP, or if ads are disabled, or if there is no text to show
  if (currentUser?.isVip || !vipSettings?.adEnabled || !vipSettings?.adText) {
    return null;
  }

  const handleBannerClick = () => {
    if (vipSettings.adLink) {
      const tg = window.Telegram?.WebApp;
      if (tg && vipSettings.adLink.includes('t.me/')) {
        tg.openTelegramLink(vipSettings.adLink);
      } else {
        window.open(vipSettings.adLink, '_blank');
      }
    }
  };

  return (
    <div 
      className={`ad-banner-container ${vipSettings.adLink ? 'clickable' : ''}`} 
      onClick={handleBannerClick}
    >
      <div className="ad-banner-glass-glow"></div>
      <div className="ad-banner-inner">
        <div className="ad-badge">
          <Megaphone size={12} className="ad-badge-icon" />
          <span>إعلان</span>
        </div>
        <div className="ad-text-content">
          {vipSettings.adText}
        </div>
        {vipSettings.adLink && (
          <div className="ad-click-indicator">
            <ExternalLink size={14} />
          </div>
        )}
      </div>
    </div>
  );
}
